import Vuex from 'vuex'
import Vue from 'vue'
import auth from "./auth";
import { config } from '../util/config'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    serverUrl: config.backendURL + '/',
    event: {},
		eventOrder: {}
  },

	getters: {
    grand_total: state => {
      return state.event.total_revenue;
    },
  },
  
  mutations: {
    storeEvent(state, event) {
      state.event = event
    }, 

		storeEventOrder(state, event) {
      state.eventOrder = event
    }, 
  },
  
  actions: {
    addEvent(context, event) {
      context.commit('storeEvent', event) 
    },

		addEventOrder(context, event) {
      context.commit('storeEventOrder', event) 
    },
  },

  modules: {
    auth
  }
});